import React, { useContext, useState, useEffect, useRef } from "react"
import { reels, icons } from "global.js"
import { GameContext } from "utils/game-context"
import { Container } from "@inlet/react-pixi"
import Reel from "components/reel"
import Anticipations from "components/anticipations"
import * as _ from "lodash"

const Reels = () => {
  const context = useContext(GameContext)
  const [counter, setCounter] = useState(0)
  const stateRefs = [1, 2, 3, 4, 5].map(x => useRef("stop"))
  const rollCache = useRef([0, 0, 0, 0, 0])
  const {
    roll,
    rollingTimeMs,
    activeItems,
    newBet,
    activeLine,
    showedLines,
    anticipation,
  } = context.state
  useEffect(() => {
    if (newBet) {
      //rollCache.current = [].concat(roll)
      setCounter(x => x + 1)
      stateRefs.forEach((x, i) => {
        x.current = "start"
        setTimeout(() => {
          x.current = "stop"
          rollCache.current[i] = roll[i]
          setCounter(x => x + 1)
        }, rollingTimeMs[i])
      })
    }
  }, [roll])

  return (
    <Container>
      {reels.map((reel, id) => (
        <Reel
          items={reel}
          // eslint-disable-next-line react/no-array-index-key
          key={id}
          roll={rollCache.current[id]}
          activeIndex={activeItems[id]}
          columnIndex={id}
          rollingTime={rollingTimeMs[id]}
          state={stateRefs[id].current}
          counter={counter}
          darken={
            !!(
              stateRefs[id].current === "stop" &&
              (activeItems.some(x => x) ||
                activeLine ||
                (showedLines && showedLines.length))
            )
          }
        />
      ))}
      <Anticipations config={anticipation || []} />
    </Container>
  )
}

export default Reels
